export const departments = [
  { label: 'Business' },
  { label: 'Engineering' },
  { label: 'Marketing' },
  { label: 'Product' },
  { label: 'Sales' },
  { label: 'G&A' },
  { label: 'People' },
  { label: 'Admin' },
  { label: 'Manufactoring' }
]

export const premisesList = [
  { label: 'Home office' },
  { label: 'Manufactoring plant' },
  { label: 'Office' },
  { label: 'Parking' },
  { label: 'Storage' },
  { label: 'Store' },
  { label: 'Warehouse' },
]

export const digitalChannels = [
  { label: 'Amazon' },
  { label: 'Facebook' },
  { label: 'Google' },
  { label: 'LinkedIn' },
  { label: 'Microsoft' },
  { label: 'Pinterest' },
  { label: 'Snapchat' },
  { label: 'TikTok' },
  { label: 'X' },
]

export const digitalAdTypes = [
  { label: 'App promotion' },
  { label: 'Display' },
  { label: 'Search' },
  { label: 'Shopping' },
  { label: 'Video' },
]

export const eventTypes = [
  { label: 'Trade show' },
  { label: 'Conference' },
  { label: 'Exhibition' },
  { label: 'Seminar' },
  { label: 'Product launch' },
]

export const researchTypes = [
  { label: 'Focus Group' },
  { label: 'Market Reports' },
  { label: 'Mystery Shopping' },
  { label: 'Social Media Monitoring' },
  { label: 'Survey' },
  { label: 'UX Research' },
]

export const brandingTypes = [
  { label: 'Brand identity' },
  { label: 'Packaging design' },
  { label: 'Website design' },
]

export const serviceTypes = [
  { label: 'Accounting' },
  { label: 'Customer Support' },
  { label: 'Facility Management' },
  { label: 'HR services' },
  { label: 'IT services' },
  { label: 'Legal services' },
]

export const equipments = [
  {label: "Microscopes"},
  {label: "Centrifuges"},
  {label: "Incubators"},
  {label: "PCR Machines"},
  {label: "Freezers"},
  {label: "Autoclaves"},
  {label: "Shakers"},
  {label: "Spectrophotometers"},
  {label: "HPLC Systems"},
  {label: "Fermenters"},
  {label: "Bioreactors"},
  {label: "Gel Electrophoresis Systems"},
  {label: "Mass Spectrometers"},
  {label: "Flow Cytometers"},
  {label: "Lab Balances"},
  {label: "Pipettes"},
  {label: "Microplate Readers"},
  {label: "Incubated Shakers"},
  {label: "Water Purification Systems"},
  {label: "Lyophilizers"},
  {label: "Gas Chromatographs"},
  {label: "Laboratory Ovens"},
  {label: "DNA Sequencers"},
  {label: "Cell Counters"},
  {label: "Microarrays"},
  {label: "Refrigerators"},
  {label: "Biosafety Cabinets"},
  {label: "PCR Thermal Cyclers"},
  {label: "Ultrasonic Cleaners"},
  {label: "Hoods"},
  {label: "CO2 Incubators"},
  {label: "ELISA Readers"},
  {label: "Microtomes"},
  {label: "DNA Synthesizers"},
  {label: "Robotics Systems"},
  {label: "Microbial Fermentation Systems"},
  {label: "Sonicators"},
  {label: "Microplate Washers"},
  {label: "NMR Spectrometers"},
  {label: "Tissue Culture Hoods"},
  {label: "Laboratory Stirrers"},
  {label: "Chromatography Systems"},
  {label: "Real-Time PCR Systems"},
  {label: "Cell Sorters"},
  {label: "Liquid Handlers"},
  {label: "Glove Boxes"},
  {label: "Lab Refrigerators"},
  {label: "Microfluidics Devices"},
  {label: "Electroporators"},
  {label: "Desiccators"},
  {label: "Analytical Balances"},
  {label: "Syringe Pumps"},
  {label: "Growth Chambers"},
  {label: "Electrophoresis Power Supplies"},
  {label: "Microarray Scanners"},
  {label: "Rotary Evaporators"},
  {label: "Magnetic Stirrers"},
  {label: "Laboratory Furnaces"},
  {label: "Imaging Systems"},
  {label: "Microdialysis Systems"},
  {label: "Microplate Sealers"},
  {label: "Laboratory Refrigerators"},
  {label: "Fraction Collectors"},
  {label: "Freeze Dryers"},
  {label: "Ultraviolet Cabinets"},
  {label: "Vacuum Pumps"},
  {label: "Nanodrop Spectrophotometers"},
  {label: "Tissue Homogenizers"},
  {label: "Thermal Cyclers"},
  {label: "Gel Documentation Systems"},
  {label: "Molecular Biology Kits"},
  {label: "Laboratory Hoods"},
  {label: "Laboratory Water Baths"},
  {label: "Capillary Electrophoresis Systems"},
  {label: "Spectrophotometers UV-Vis"},
  {label: "Genomic DNA Extraction Kits"},
  {label: "Lab Incubators"},
  {label: "Biological Safety Cabinets"},
  {label: "Western Blot Imaging Systems"},
  {label: "Hematology Analyzers"},
  {label: "PCR Workstations"},
  {label: "Tissue Culture Incubators"},
  {label: "Laboratory Autoclaves"},
  {label: "Dissolved Oxygen Meters"},
  {label: "Laboratory Refrigerator-Freezers"},
  {label: "Sonicators"},
  {label: "Gel Documentation and Imaging Systems"},
  {label: "Laboratory Water Purification Systems"},
  {label: "Homogenizers"},
  {label: "Particle Size Analyzers"},
  {label: "Environmental Chambers"},
  {label: "Electrophoresis Systems"},
  {label: "Microbiology Culture Systems"},
  {label: "Plasma Thawers"},
  {label: "Laboratory Filtration Systems"},
  {label: "Bioinformatics Software"},
  {label: "Blood Bank Refrigerators"},
  {label: "DNA Extraction Kits"},
  {label: "Cell Culture Systems"},
  {label: "Laboratory Chillers"},
  {label: "Oscilloscopes"},
  {label: "Multimeters"},
  {label: "Power Supplies"},
  {label: "Soldering Stations"},
  {label: "Function Generators"},
  {label: "Digital Calipers"},
  {label: "Logic Analyzers"},
  {label: "Signal Generators"},
  {label: "Spectrum Analyzers"},
  {label: "Bench Power Supplies"},
  {label: "Waveform Generators"},
  {label: "Electronic Loads"},
  {label: "Frequency Counters"},
  {label: "LCR Meters"},
  {label: "Electrical Testers"},
  {label: "Voltage Testers"},
  {label: "EMI Test Equipment"},
  {label: "Probes"},
  {label: "Network Analyzers"},
  {label: "Component Testers"},
  {label: "Curve Tracers"},
  {label: "Cable Testers"},
  {label: "Laser Diode Testers"},
  {label: "Environmental Chambers"},
  {label: "Electrostatic Discharge (ESD) Testers"},
  {label: "Digital Storage Oscilloscopes"},
  {label: "Analog Oscilloscopes"},
  {label: "High Voltage Probes"},
  {label: "Ground Resistance Testers"},
  {label: "Dielectric Strength Testers"},
  {label: "Power Analyzers"},
  {label: "Insulation Testers"},
  {label: "Frequency Synthesizers"},
  {label: "Digital Meters"},
  {label: "Temperature Controllers"},
  {label: "Loudness Meters"},
  {label: "Pulse Generators"},
  {label: "Pressure Sensors"},
  {label: "Temperature Sensors"},
  {label: "Humidity Sensors"},
  {label: "Motion Sensors"},
  {label: "Proximity Sensors"},
  {label: "Accelerometers"},
  {label: "Gyroscopes"},
  {label: "Inclinometers"},
  {label: "Force Sensors"},
  {label: "Load Cells"},
  {label: "Strain Gauges"},
  {label: "Photoelectric Sensors"},
  {label: "Ultrasonic Sensors"},
  {label: "Hall Effect Sensors"},
  {label: "Magnetic Sensors"},
  {label: "Pressure Transducers"},
  {label: "Level Sensors"},
  {label: "Flow Sensors"},
  {label: "Liquid Sensors"},
  {label: "Gas Sensors"},
  {label: "Smoke Sensors"},
  {label: "Flame Sensors"},
  {label: "Sound Sensors"},
  {label: "Color Sensors"},
  {label: "Light Sensors"},
  {label: "IR Sensors"},
  {label: "UV Sensors"},
  {label: "Proximity Sensors"},
  {label: "Capacitive Sensors"},
  {label: "Inductive Sensors"},
  {label: "Optical Sensors"},
  {label: "RFID Readers"},
  {label: "Barcode Scanners"},
  {label: "Magnetic Card Readers"},
  {label: "Biometric Sensors"},
  {label: "Thermal Cameras"},
  {label: "Infrared Thermometers"},
  {label: "Temperature Controllers"},
  {label: "Humidity Controllers"},
  {label: "Thermostats"},
  {label: "PID Controllers"},
  {label: "Temperature Data Loggers"},
  {label: "Voltage Data Loggers"},
  {label: "Current Data Loggers"},
  {label: "Pressure Data Loggers"},
  {label: "Flow Data Loggers"},
  {label: "Humidity Data Loggers"},
  {label: "Light Data Loggers"},
  {label: "Sound Data Loggers"},
  {label: "RF Data Loggers"},
  {label: "Motion Data Loggers"},
  {label: "Vibration Data Loggers"},
  {label: "Acceleration Data Loggers"},
  {label: "Force Data Loggers"},
  {label: "Torque Data Loggers"},
  {label: "Energy Data Loggers"},
  {label: "Power Quality Analyzers"},
  {label: "Surge Protectors"},
  {label: "Voltage Regulators"},
  {label: "Inverters"},
  {label: "UPS Systems"},
  {label: "Battery Chargers"},
  {label: "Battery Testers"},
  {label: "Battery Dischargers"},
  {label: "Laptops"},
  {label: "Desktop Computers"},
  {label: "Servers"},
  {label: "Networking Equipment"},
  {label: "Printers"},
  {label: "Scanners"},
  {label: "Projectors"},
  {label: "Monitors"},
  {label: "Keyboards"},
  {label: "Computer Mice"},
  {label: "Webcams"},
  {label: "Headsets"},
  {label: "External Hard Drives"},
  {label: "USB Flash Drives"},
  {label: "Routers"},
  {label: "Switches"},
  {label: "Access Points"},
  {label: "Firewalls"},
  {label: "Backup Solutions"},
  {label: "Antivirus Software"},
  {label: "Data Recovery Software"},
  {label: "Cloud Storage Services"},
  {label: "Virtual Private Network (VPN) Services"},
  {label: "Remote Desktop Software"},
  {label: "Office Productivity Software"},
  {label: "Accounting Software"},
  {label: "Customer Relationship Management (CRM) Software"},
  {label: "Enterprise Resource Planning (ERP) Software"},
  {label: "Project Management Software"},
  {label: "Collaboration Tools"},
  {label: "Web Hosting Services"},
  {label: "Domain Registration Services"},
  {label: "Email Hosting Services"},
  {label: "Data Backup Services"},
  {label: "IT Consulting Services"},
  {label: "Network Security Services"},
  {label: "Technical Support Services"},
  {label: "Managed IT Services"},
  {label: "Disaster Recovery Services"},
  {label: "Cloud Computing Services"},
  {label: "Infrastructure as a Service (IaaS)"},
  {label: "Platform as a Service (PaaS)"},
  {label: "Software as a Service (SaaS)"},
  {label: "Cybersecurity Services"},
  {label: "Penetration Testing Services"},
  {label: "Security Awareness Training"},
  {label: "Data Protection Solutions"},
  {label: "Endpoint Security Solutions"},
  {label: "Network Monitoring Solutions"},
  {label: "Data Analytics Software"},
  {label: "Business Intelligence Tools"},
  {label: "Big Data Solutions"},
  {label: "Machine Learning Platforms"},
  {label: "Artificial Intelligence Solutions"},
  {label: "Internet of Things (IoT) Devices"},
  {label: "Smartphones"},
  {label: "Tablets"},
  {label: "Wireless Chargers"},
  {label: "Bluetooth Speakers"},
  {label: "Smartwatches"},
  {label: "Fitness Trackers"},
  {label: "Digital Cameras"},
  {label: "Drones"},
  {label: "Gaming Consoles"},
  {label: "Gaming PCs"},
  {label: "Gaming Accessories"},
  {label: "Virtual Reality (VR) Headsets"},
  {label: "Augmented Reality (AR) Devices"},
  {label: "Robotics Kits"},
  {label: "Educational Software"},
  {label: "Educational Apps"},
  {label: "Learning Management Systems (LMS)"},
  {label: "Online Course Platforms"},
  {label: "Coding Bootcamps"},
  {label: "Technical Certifications"},
  {label: "IT Training Courses"},
  {label: "IT Books"},
  {label: "Professional Memberships"},
  {label: "Conference Tickets"},
  {label: "Webinar Registrations"},
  {label: "Online Training Subscriptions"},
  {label: "Productivity Tools"},
  {label: "Collaboration Platforms"},
  {label: "Task Management Software"},
  {label: "Time Tracking Tools"},
  {label: "Document Management Systems"},
  {label: "Expense Management Software"},
  {label: "Invoicing Software"},
  {label: "Payment Processing Solutions"},
  {label: "E-commerce Platforms"},
  {label: "Website Builders"},
  {label: "Content Management Systems (CMS)"},
  {label: "SEO Tools"},
  {label: "Social Media Management Platforms"},
  {label: "Digital Marketing Software"},
  {label: "Analytics Tools"},
  {label: "Customer Support Software"},
  {label: "Live Chat Solutions"},
  {label: "Help Desk Software"},
  {label: "Ticketing Systems"},
  {label: "Knowledge Base Software"},
  {label: "Community Forums"},
  {label: "Survey Tools"},
  {label: "Feedback Management Software"},
  {label: "Desks"},
  {label: "Office Chairs"},
  {label: "Computers"},
  {label: "Printers"},
  {label: "Scanners"},
  {label: "Telephones"},
  {label: "Fax Machines"},
  {label: "Photocopiers"},
  {label: "Shredders"},
  {label: "Projectors"},
  {label: "Whiteboards"},
  {label: "File Cabinets"},
  {label: "Bookshelves"},
  {label: "Storage Cabinets"},
  {label: "Office Supplies"},
  {label: "Stationery"},
  {label: "Filing Trays"},
  {label: "Desk Organizers"},
  {label: "Paper Shredders"},
  {label: "Safety Equipment"},
  {label: "First Aid Kits"},
  {label: "Fire Extinguishers"},
  {label: "Smoke Detectors"},
  {label: "Lighting Fixtures"},
  {label: "Desk Lamps"},
  {label: "Ceiling Lights"},
  {label: "Floor Lamps"},
  {label: "Office Decorations"},
  {label: "Artwork"},
  {label: "Plants"},
  {label: "Curtains"},
  {label: "Rugs"},
  {label: "Clocks"},
  {label: "Desk Accessories"},
  {label: "Mouse Pads"},
  {label: "Desk Mats"},
  {label: "Cable Management Solutions"},
  {label: "Power Strips"},
  {label: "Surge Protectors"},
  {label: "Extension Cords"},
  {label: "Networking Equipment"},
  {label: "Routers"},
  {label: "Switches"},
  {label: "Access Points"},
  {label: "Cables and Connectors"},
  {label: "Wireless Adapters"},
  {label: "Keyboard and Mouse Sets"},
  {label: "Headsets"},
  {label: "Webcams"},
  {label: "Speakers"},
  {label: "Machinery"},
  {label: "Conveyors"},
  {label: "Forklifts"},
  {label: "Packaging Machines"},
  {label: "Assembly Lines"},
  {label: "Robotics"},
  {label: "Industrial Ovens"},
  {label: "Mixers"},
  {label: "Grinders"},
  {label: "Cutting Machines"},
  {label: "Lathes"},
  {label: "Presses"},
  {label: "Welding Equipment"},
  {label: "Drilling Machines"},
  {label: "Saws"},
  {label: "CNC Machines"},
  {label: "Injection Molding Machines"},
  {label: "Extrusion Machines"},
  {label: "Stamping Machines"},
  {label: "Paint Booths"},
  {label: "Spray Guns"},
  {label: "Rolling Mills"},
  {label: "Cranes"},
  {label: "Hoists"},
  {label: "Palletizers"},
  {label: "Storage Tanks"},
  {label: "Mixing Tanks"},
  {label: "Filling Machines"},
  {label: "Labeling Machines"},
  {label: "Sealing Machines"},
  {label: "Weighing Scales"},
  {label: "Packaging Materials"},
  {label: "Pallets"},
  {label: "Containers"},
  {label: "Wrapping Materials"},
  {label: "Safety Equipment"},
  {label: "Helmets"},
  {label: "Gloves"},
  {label: "Protective Clothing"},
  {label: "Safety Glasses"},
  {label: "Ear Protection"},
  {label: "Footwear"},
  {label: "Fire Extinguishers"},
  {label: "First Aid Kits"},
  {label: "Emergency Showers"},
  {label: "Eye Wash Stations"},
  {label: "Safety Signs"},
  {label: "Lockout Tagout Devices"},
  {label: "Safety Barriers"},
  {label: "Car"},

]

export const frequencyPaymentTypes = [
  { label: 'yearly', multiple: 1 },
  { label: 'quarterly', multiple: 4 },
  { label: 'monthly', multiple: 12 },  
  { label: 'daily', multiple: 365 },
]

// From https://bitbucket.org/atlassian/atlaskit-mk-2/raw/4ad0e56649c3e6c973e226b7efaeb28cb240ccb0/packages/core/select/src/data/countries.js
export const countries = [
  { code: 'AD', label: 'Andorra', phone: '376' },
  {
    code: 'AE',
    label: 'United Arab Emirates',
    phone: '971',
  },
  { code: 'AF', label: 'Afghanistan', phone: '93' },
  {
    code: 'AG',
    label: 'Antigua and Barbuda',
    phone: '1-268',
  },
  { code: 'AI', label: 'Anguilla', phone: '1-264' },
  { code: 'AL', label: 'Albania', phone: '355' },
  { code: 'AM', label: 'Armenia', phone: '374' },
  { code: 'AO', label: 'Angola', phone: '244' },
  { code: 'AQ', label: 'Antarctica', phone: '672' },
  { code: 'AR', label: 'Argentina', phone: '54' },
  { code: 'AS', label: 'American Samoa', phone: '1-684' },
  { code: 'AT', label: 'Austria', phone: '43' },
  {
    code: 'AU',
    label: 'Australia',
    phone: '61',
    suggested: true,
  },
  { code: 'AW', label: 'Aruba', phone: '297' },
  { code: 'AX', label: 'Alland Islands', phone: '358' },
  { code: 'AZ', label: 'Azerbaijan', phone: '994' },
  {
    code: 'BA',
    label: 'Bosnia and Herzegovina',
    phone: '387',
  },
  { code: 'BB', label: 'Barbados', phone: '1-246' },
  { code: 'BD', label: 'Bangladesh', phone: '880' },
  { code: 'BE', label: 'Belgium', phone: '32' },
  { code: 'BF', label: 'Burkina Faso', phone: '226' },
  { code: 'BG', label: 'Bulgaria', phone: '359' },
  { code: 'BH', label: 'Bahrain', phone: '973' },
  { code: 'BI', label: 'Burundi', phone: '257' },
  { code: 'BJ', label: 'Benin', phone: '229' },
  { code: 'BL', label: 'Saint Barthelemy', phone: '590' },
  { code: 'BM', label: 'Bermuda', phone: '1-441' },
  { code: 'BN', label: 'Brunei Darussalam', phone: '673' },
  { code: 'BO', label: 'Bolivia', phone: '591' },
  { code: 'BR', label: 'Brazil', phone: '55' },
  { code: 'BS', label: 'Bahamas', phone: '1-242' },
  { code: 'BT', label: 'Bhutan', phone: '975' },
  { code: 'BV', label: 'Bouvet Island', phone: '47' },
  { code: 'BW', label: 'Botswana', phone: '267' },
  { code: 'BY', label: 'Belarus', phone: '375' },
  { code: 'BZ', label: 'Belize', phone: '501' },
  {
    code: 'CA',
    label: 'Canada',
    phone: '1',
    suggested: true,
  },
  {
    code: 'CC',
    label: 'Cocos (Keeling) Islands',
    phone: '61',
  },
  {
    code: 'CD',
    label: 'Congo, Democratic Republic of the',
    phone: '243',
  },
  {
    code: 'CF',
    label: 'Central African Republic',
    phone: '236',
  },
  {
    code: 'CG',
    label: 'Congo, Republic of the',
    phone: '242',
  },
  { code: 'CH', label: 'Switzerland', phone: '41' },
  { code: 'CI', label: "Cote d'Ivoire", phone: '225' },
  { code: 'CK', label: 'Cook Islands', phone: '682' },
  { code: 'CL', label: 'Chile', phone: '56' },
  { code: 'CM', label: 'Cameroon', phone: '237' },
  { code: 'CN', label: 'China', phone: '86' },
  { code: 'CO', label: 'Colombia', phone: '57' },
  { code: 'CR', label: 'Costa Rica', phone: '506' },
  { code: 'CU', label: 'Cuba', phone: '53' },
  { code: 'CV', label: 'Cape Verde', phone: '238' },
  { code: 'CW', label: 'Curacao', phone: '599' },
  { code: 'CX', label: 'Christmas Island', phone: '61' },
  { code: 'CY', label: 'Cyprus', phone: '357' },
  { code: 'CZ', label: 'Czech Republic', phone: '420' },
  {
    code: 'DE',
    label: 'Germany',
    phone: '49',
    suggested: true,
  },
  { code: 'DJ', label: 'Djibouti', phone: '253' },
  { code: 'DK', label: 'Denmark', phone: '45' },
  { code: 'DM', label: 'Dominica', phone: '1-767' },
  {
    code: 'DO',
    label: 'Dominican Republic',
    phone: '1-809',
  },
  { code: 'DZ', label: 'Algeria', phone: '213' },
  { code: 'EC', label: 'Ecuador', phone: '593' },
  { code: 'EE', label: 'Estonia', phone: '372' },
  { code: 'EG', label: 'Egypt', phone: '20' },
  { code: 'EH', label: 'Western Sahara', phone: '212' },
  { code: 'ER', label: 'Eritrea', phone: '291' },
  { code: 'ES', label: 'Spain', phone: '34' },
  { code: 'ET', label: 'Ethiopia', phone: '251' },
  { code: 'FI', label: 'Finland', phone: '358' },
  { code: 'FJ', label: 'Fiji', phone: '679' },
  {
    code: 'FK',
    label: 'Falkland Islands (Malvinas)',
    phone: '500',
  },
  {
    code: 'FM',
    label: 'Micronesia, Federated States of',
    phone: '691',
  },
  { code: 'FO', label: 'Faroe Islands', phone: '298' },
  {
    code: 'FR',
    label: 'France',
    phone: '33',
    suggested: true,
  },
  { code: 'GA', label: 'Gabon', phone: '241' },
  { code: 'GB', label: 'United Kingdom', phone: '44' },
  { code: 'GD', label: 'Grenada', phone: '1-473' },
  { code: 'GE', label: 'Georgia', phone: '995' },
  { code: 'GF', label: 'French Guiana', phone: '594' },
  { code: 'GG', label: 'Guernsey', phone: '44' },
  { code: 'GH', label: 'Ghana', phone: '233' },
  { code: 'GI', label: 'Gibraltar', phone: '350' },
  { code: 'GL', label: 'Greenland', phone: '299' },
  { code: 'GM', label: 'Gambia', phone: '220' },
  { code: 'GN', label: 'Guinea', phone: '224' },
  { code: 'GP', label: 'Guadeloupe', phone: '590' },
  { code: 'GQ', label: 'Equatorial Guinea', phone: '240' },
  { code: 'GR', label: 'Greece', phone: '30' },
  {
    code: 'GS',
    label: 'South Georgia and the South Sandwich Islands',
    phone: '500',
  },
  { code: 'GT', label: 'Guatemala', phone: '502' },
  { code: 'GU', label: 'Guam', phone: '1-671' },
  { code: 'GW', label: 'Guinea-Bissau', phone: '245' },
  { code: 'GY', label: 'Guyana', phone: '592' },
  { code: 'HK', label: 'Hong Kong', phone: '852' },
  {
    code: 'HM',
    label: 'Heard Island and McDonald Islands',
    phone: '672',
  },
  { code: 'HN', label: 'Honduras', phone: '504' },
  { code: 'HR', label: 'Croatia', phone: '385' },
  { code: 'HT', label: 'Haiti', phone: '509' },
  { code: 'HU', label: 'Hungary', phone: '36' },
  { code: 'ID', label: 'Indonesia', phone: '62' },
  { code: 'IE', label: 'Ireland', phone: '353' },
  { code: 'IL', label: 'Israel', phone: '972' },
  { code: 'IM', label: 'Isle of Man', phone: '44' },
  { code: 'IN', label: 'India', phone: '91' },
  {
    code: 'IO',
    label: 'British Indian Ocean Territory',
    phone: '246',
  },
  { code: 'IQ', label: 'Iraq', phone: '964' },
  {
    code: 'IR',
    label: 'Iran, Islamic Republic of',
    phone: '98',
  },
  { code: 'IS', label: 'Iceland', phone: '354' },
  { code: 'IT', label: 'Italy', phone: '39' },
  { code: 'JE', label: 'Jersey', phone: '44' },
  { code: 'JM', label: 'Jamaica', phone: '1-876' },
  { code: 'JO', label: 'Jordan', phone: '962' },
  {
    code: 'JP',
    label: 'Japan',
    phone: '81',
    suggested: true,
  },
  { code: 'KE', label: 'Kenya', phone: '254' },
  { code: 'KG', label: 'Kyrgyzstan', phone: '996' },
  { code: 'KH', label: 'Cambodia', phone: '855' },
  { code: 'KI', label: 'Kiribati', phone: '686' },
  { code: 'KM', label: 'Comoros', phone: '269' },
  {
    code: 'KN',
    label: 'Saint Kitts and Nevis',
    phone: '1-869',
  },
  {
    code: 'KP',
    label: "Korea, Democratic People's Republic of",
    phone: '850',
  },
  { code: 'KR', label: 'Korea, Republic of', phone: '82' },
  { code: 'KW', label: 'Kuwait', phone: '965' },
  { code: 'KY', label: 'Cayman Islands', phone: '1-345' },
  { code: 'KZ', label: 'Kazakhstan', phone: '7' },
  {
    code: 'LA',
    label: "Lao People's Democratic Republic",
    phone: '856',
  },
  { code: 'LB', label: 'Lebanon', phone: '961' },
  { code: 'LC', label: 'Saint Lucia', phone: '1-758' },
  { code: 'LI', label: 'Liechtenstein', phone: '423' },
  { code: 'LK', label: 'Sri Lanka', phone: '94' },
  { code: 'LR', label: 'Liberia', phone: '231' },
  { code: 'LS', label: 'Lesotho', phone: '266' },
  { code: 'LT', label: 'Lithuania', phone: '370' },
  { code: 'LU', label: 'Luxembourg', phone: '352' },
  { code: 'LV', label: 'Latvia', phone: '371' },
  { code: 'LY', label: 'Libya', phone: '218' },
  { code: 'MA', label: 'Morocco', phone: '212' },
  { code: 'MC', label: 'Monaco', phone: '377' },
  {
    code: 'MD',
    label: 'Moldova, Republic of',
    phone: '373',
  },
  { code: 'ME', label: 'Montenegro', phone: '382' },
  {
    code: 'MF',
    label: 'Saint Martin (French part)',
    phone: '590',
  },
  { code: 'MG', label: 'Madagascar', phone: '261' },
  { code: 'MH', label: 'Marshall Islands', phone: '692' },
  {
    code: 'MK',
    label: 'Macedonia, the Former Yugoslav Republic of',
    phone: '389',
  },
  { code: 'ML', label: 'Mali', phone: '223' },
  { code: 'MM', label: 'Myanmar', phone: '95' },
  { code: 'MN', label: 'Mongolia', phone: '976' },
  { code: 'MO', label: 'Macao', phone: '853' },
  {
    code: 'MP',
    label: 'Northern Mariana Islands',
    phone: '1-670',
  },
  { code: 'MQ', label: 'Martinique', phone: '596' },
  { code: 'MR', label: 'Mauritania', phone: '222' },
  { code: 'MS', label: 'Montserrat', phone: '1-664' },
  { code: 'MT', label: 'Malta', phone: '356' },
  { code: 'MU', label: 'Mauritius', phone: '230' },
  { code: 'MV', label: 'Maldives', phone: '960' },
  { code: 'MW', label: 'Malawi', phone: '265' },
  { code: 'MX', label: 'Mexico', phone: '52' },
  { code: 'MY', label: 'Malaysia', phone: '60' },
  { code: 'MZ', label: 'Mozambique', phone: '258' },
  { code: 'NA', label: 'Namibia', phone: '264' },
  { code: 'NC', label: 'New Caledonia', phone: '687' },
  { code: 'NE', label: 'Niger', phone: '227' },
  { code: 'NF', label: 'Norfolk Island', phone: '672' },
  { code: 'NG', label: 'Nigeria', phone: '234' },
  { code: 'NI', label: 'Nicaragua', phone: '505' },
  { code: 'NL', label: 'Netherlands', phone: '31' },
  { code: 'NO', label: 'Norway', phone: '47' },
  { code: 'NP', label: 'Nepal', phone: '977' },
  { code: 'NR', label: 'Nauru', phone: '674' },
  { code: 'NU', label: 'Niue', phone: '683' },
  { code: 'NZ', label: 'New Zealand', phone: '64' },
  { code: 'OM', label: 'Oman', phone: '968' },
  { code: 'PA', label: 'Panama', phone: '507' },
  { code: 'PE', label: 'Peru', phone: '51' },
  { code: 'PF', label: 'French Polynesia', phone: '689' },
  { code: 'PG', label: 'Papua New Guinea', phone: '675' },
  { code: 'PH', label: 'Philippines', phone: '63' },
  { code: 'PK', label: 'Pakistan', phone: '92' },
  { code: 'PL', label: 'Poland', phone: '48' },
  {
    code: 'PM',
    label: 'Saint Pierre and Miquelon',
    phone: '508',
  },
  { code: 'PN', label: 'Pitcairn', phone: '870' },
  { code: 'PR', label: 'Puerto Rico', phone: '1' },
  {
    code: 'PS',
    label: 'Palestine, State of',
    phone: '970',
  },
  { code: 'PT', label: 'Portugal', phone: '351' },
  { code: 'PW', label: 'Palau', phone: '680' },
  { code: 'PY', label: 'Paraguay', phone: '595' },
  { code: 'QA', label: 'Qatar', phone: '974' },
  { code: 'RE', label: 'Reunion', phone: '262' },
  { code: 'RO', label: 'Romania', phone: '40' },
  { code: 'RS', label: 'Serbia', phone: '381' },
  { code: 'RU', label: 'Russian Federation', phone: '7' },
  { code: 'RW', label: 'Rwanda', phone: '250' },
  { code: 'SA', label: 'Saudi Arabia', phone: '966' },
  { code: 'SB', label: 'Solomon Islands', phone: '677' },
  { code: 'SC', label: 'Seychelles', phone: '248' },
  { code: 'SD', label: 'Sudan', phone: '249' },
  { code: 'SE', label: 'Sweden', phone: '46' },
  { code: 'SG', label: 'Singapore', phone: '65' },
  { code: 'SH', label: 'Saint Helena', phone: '290' },
  { code: 'SI', label: 'Slovenia', phone: '386' },
  {
    code: 'SJ',
    label: 'Svalbard and Jan Mayen',
    phone: '47',
  },
  { code: 'SK', label: 'Slovakia', phone: '421' },
  { code: 'SL', label: 'Sierra Leone', phone: '232' },
  { code: 'SM', label: 'San Marino', phone: '378' },
  { code: 'SN', label: 'Senegal', phone: '221' },
  { code: 'SO', label: 'Somalia', phone: '252' },
  { code: 'SR', label: 'Suriname', phone: '597' },
  { code: 'SS', label: 'South Sudan', phone: '211' },
  {
    code: 'ST',
    label: 'Sao Tome and Principe',
    phone: '239',
  },
  { code: 'SV', label: 'El Salvador', phone: '503' },
  {
    code: 'SX',
    label: 'Sint Maarten (Dutch part)',
    phone: '1-721',
  },
  {
    code: 'SY',
    label: 'Syrian Arab Republic',
    phone: '963',
  },
  { code: 'SZ', label: 'Swaziland', phone: '268' },
  {
    code: 'TC',
    label: 'Turks and Caicos Islands',
    phone: '1-649',
  },
  { code: 'TD', label: 'Chad', phone: '235' },
  {
    code: 'TF',
    label: 'French Southern Territories',
    phone: '262',
  },
  { code: 'TG', label: 'Togo', phone: '228' },
  { code: 'TH', label: 'Thailand', phone: '66' },
  { code: 'TJ', label: 'Tajikistan', phone: '992' },
  { code: 'TK', label: 'Tokelau', phone: '690' },
  { code: 'TL', label: 'Timor-Leste', phone: '670' },
  { code: 'TM', label: 'Turkmenistan', phone: '993' },
  { code: 'TN', label: 'Tunisia', phone: '216' },
  { code: 'TO', label: 'Tonga', phone: '676' },
  { code: 'TR', label: 'Turkey', phone: '90' },
  {
    code: 'TT',
    label: 'Trinidad and Tobago',
    phone: '1-868',
  },
  { code: 'TV', label: 'Tuvalu', phone: '688' },
  {
    code: 'TW',
    label: 'Taiwan',
    phone: '886',
  },
  {
    code: 'TZ',
    label: 'United Republic of Tanzania',
    phone: '255',
  },
  { code: 'UA', label: 'Ukraine', phone: '380' },
  { code: 'UG', label: 'Uganda', phone: '256' },
  {
    code: 'US',
    label: 'United States',
    phone: '1',
    suggested: true,
  },
  { code: 'UY', label: 'Uruguay', phone: '598' },
  { code: 'UZ', label: 'Uzbekistan', phone: '998' },
  {
    code: 'VA',
    label: 'Holy See (Vatican City State)',
    phone: '379',
  },
  {
    code: 'VC',
    label: 'Saint Vincent and the Grenadines',
    phone: '1-784',
  },
  { code: 'VE', label: 'Venezuela', phone: '58' },
  {
    code: 'VG',
    label: 'British Virgin Islands',
    phone: '1-284',
  },
  {
    code: 'VI',
    label: 'US Virgin Islands',
    phone: '1-340',
  },
  { code: 'VN', label: 'Vietnam', phone: '84' },
  { code: 'VU', label: 'Vanuatu', phone: '678' },
  { code: 'WF', label: 'Wallis and Futuna', phone: '681' },
  { code: 'WS', label: 'Samoa', phone: '685' },
  { code: 'XK', label: 'Kosovo', phone: '383' },
  { code: 'YE', label: 'Yemen', phone: '967' },
  { code: 'YT', label: 'Mayotte', phone: '262' },
  { code: 'ZA', label: 'South Africa', phone: '27' },
  { code: 'ZM', label: 'Zambia', phone: '260' },
  { code: 'ZW', label: 'Zimbabwe', phone: '263' },
];

export const titles = [
  { label: "CEO" },
  { label: "COO" },
  { label: "CFO" },
  { label: "CIO" },
  { label: "CTO" },
  { label: "CMO" },
  { label: "CHRO" },
  { label: "CDO" },
  { label: "CPO" },
  { label: "CCO" },
  { label: "Team Leader" },
  { label: "Manager" },
  { label: "Assistant Manager" },
  { label: "Executive" },
  { label: "Director" },
  { label: "Coordinator" },
  { label: "Administrator" },
  { label: "Officer" },
  { label: "Organizer" },
  { label: "Supervisor" },
  { label: "Superintendent" },
  { label: "Data Scientist" },
  { label: "Data Engineer" },
  { label: "IT Professional" },
  { label: "UX Designer" },
  { label: "SQL Developer" },
  { label: "Web Designer" },
  { label: "Web Developer" },
  { label: "Help Desk Worker" },
  { label: "Software Engineer" },
  { label: "Data Entry" },
  { label: "DevOps Engineer" },
  { label: "Computer Programmer" },
  { label: "Network Administrator" },
  { label: "Information Security Analyst" },
  { label: "Artificial Intelligence Engineer" },
  { label: "Cloud Architect" },
  { label: "IT Manager" },
  { label: "Technical Specialist" },
  { label: "Application Developer" },
  { label: "Retail Worker" },
  { label: "Sales Representative" },
  { label: "Sales Manager" },
  { label: "Real Estate Broker" },
  { label: "Sales Associate" },
  { label: "Cashier" },
  { label: "Store Manager" },
  { label: "Account Executive" },
  { label: "Account Manager" },
  { label: "Area Sales Manager" },
  { label: "Direct Salesperson" },
  { label: "Director of Inside Sales" },
  { label: "Outside Sales Manager" },
  { label: "Sales Analyst" },
  { label: "Market Development Manager" },
  { label: "B2B Sales Specialist" },
  { label: "Merchandising Associate" },
  { label: "Virtual Assistant" },
  { label: "Customer Service" },
  { label: "Customer Support" },
  { label: "Concierge" },
  { label: "Help Desk" },
  { label: "Customer Service Manager" },
  { label: "Technical Support Specialist" },
  { label: "Account Representative" },
  { label: "Client Service Specialist" },
  { label: "Customer Care Associate" },
  { label: "Credit Authorizer" },
  { label: "Benefits Manager" },
  { label: "Credit Counselor" },
  { label: "Accountant" },
  { label: "Bookkeeper" },
  { label: "Accounting Analyst" },
  { label: "Accounting Director" },
  { label: "Accounts Payable" },
  { label: "Auditor" },
  { label: "Budget Analyst" },
  { label: "Controller" },
  { label: "Financial Analyst" },
  { label: "Finance Manager" },
  { label: "Economist" },
  { label: "Payroll Manager" },
  { label: "Payroll Clerk" },
  { label: "Financial Planner" },
  { label: "Financial Services Representative" },
  { label: "Finance Director" },
  { label: "Commercial Loan Officer" },
  { label: "Engineer" },
  { label: "Mechanical Engineer" },
  { label: "Civil Engineer" },
  { label: "Electrical Engineer" },
  { label: "Assistant Engineer" },
  { label: "Chemical Engineer" },
  { label: "Chief Engineer" },
  { label: "Geological Engineer" },
  { label: "Biological Engineer" },
  { label: "Maintenance Engineer" },
  { label: "Mining Engineer" },
  { label: "Nuclear Engineer" },
  { label: "Petroleum Engineer" },
  { label: "Plant Engineer" },
  { label: "Production Engineer" },
  { label: "Quality Engineer" },
  { label: "Safety Engineer" },
  { label: "Sales Engineer" },
]

export const units = [
  { label: "m"},
  { label: "km"},  
  { label: "m²"},
  { label: "m³"},
  { label: "g"},
  { label: "kg"},
  { label: "ton"},
  { label: "vehicle"},
  { label: "machine"},
  { label: "unit"},  
  { label: "bottle"},  
  { label: "barrel"},
  { label: "user"},
  { label: "license"},  
]